import { Request, RequestV2, getHeaders } from './utils';
import * as Selectors from '../redux/selectors';
import moment from 'moment-mini';

export function getPreferences() {
  return Request.GET('preferences');
}

export function getFeatureFlags() {
  return Request.GET('featureFlags');
}

// SOURCES
export function getAvailableSources() {
  return Request.GET('availableSources');
}

// connectors
export function getAvailableConnectors(env = Selectors.getEnvId()){
  return Request.GET(`v2/${env}/availableConnectors`, undefined, { env: false})
}

// ACCESS TOKEN
export function getAccessToken(entityId, entityType, flowId, userId = Selectors.getTenantId()) {
  return Request.GET(`${flowId}/${userId}/${entityType}/${entityId}/getAccessToken`);
}

export function getLinkedSources(
  tapName,
  catalog = false,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  let url = `${flow}/${userId}/linkedSources?config=true&login_state=true`;

  if (tapName) url = `${url}&tap_name=${tapName}`;

  if (catalog) url = `${url}&catalog=true`;


  return Request.GET(url);
}

export function addLinkedSource(source, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const url = `${flow}/${userId}/linkedSources`;

  return Request.POST(url, { body: JSON.stringify({ source }) });
}

export function disconnectLinkedSource(tapName, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const url = `${flow}/${userId}/linkedSources?tap_name=${tapName}`;

  return Request.DELETE(url);
}

export function getSupportedSources(flow, catalog = false) {
  let url = `${flow}/supportedSources?`;
  if (catalog) url = `${url}&catalog=true`;

  return Request.GET(url);
}

// TARGETS
export function getLinkedTargets(targetName, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId(), catalog = false) {
  let url = `${flow}/${userId}/linkedTargets?config=true&login_state=true`;

  if (catalog) url = `${url}&catalog=true`;

  if (targetName) url = `${url}&target_name=${targetName}`;

  return Request.GET(url);
}

export function disconnectLinkedTarget(
  targetName,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedTargets?target_name=${targetName}`;

  return Request.DELETE(url);
}

export function addLinkedTarget(target, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const url = `${flow}/${userId}/linkedTargets`;

  return Request.POST(url, { body: JSON.stringify({ target }) });
}

export function getSupportedTargets(flow) {
  return Request.GET(`${flow}/supportedTargets`);
}

export function getAvailableTargets() {
  return Request.GET('availableTargets');
}

// CONNECTORS
export function getSupportedConnectors(flowId) {
  return RequestV2.GET(`${flowId}/supportedConnectors`);
}

export function getLinkedConnectors(connectorId = undefined, catalogRequested = false, flowId = Selectors.getSelectedFlow(), tenantId = Selectors.getTenantId()) {
  let url = `${flowId}/${tenantId}/linkedConnectors?config=true`;

  if (connectorId) {
    url += `&connector_id=${connectorId}`;
  }

  if (catalogRequested) {
    url += `&catalog=true`;
  }

  return RequestV2.GET(url);
}

export function addLinkedConnector(connector, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {

  return RequestV2.POST(`${flow}/${userId}/linkedConnectors`, { body: JSON.stringify({ connector }) });
}

export function disconnectLinkedConnector(
  connectorId,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const searchParams = new URLSearchParams();

  searchParams.set('connector_id', connectorId);

  return RequestV2.DELETE(`${flow}/${userId}/linkedConnectors?${searchParams.toString()}`);
}

// FLOWS
export function getSupportedFlows() {
  return Request.GET('flows/supported');
}
export function getSupportedFlow(flow) {
  return Request.GET(`flows/${flow}/supported`)
}

export function getLinkedFlows(userId = Selectors.getTenantId()) {
  const url = `flows/linked?user_id=${userId}`;

  return Request.GET(url);
}

export async function initializeOauth1Flow(tapName, values, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const url = `${flow}/${userId}/linkedSources/oauth1_authorize_url?tap_name=${tapName}`;

  const { url: authorizeUrl } = await Request.POST(url, { body: JSON.stringify(values) });

  return authorizeUrl;
}
// SHEETS
export function getSheetsFiles(entityId = '', query = '', flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.GET(`${flow}/${userId}/taps/sheets?query=${query}&tap_name=${entityId}`);
}

// SFTP-FILES
export function getSftpFiles(path = '/', flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.GET(`${flow}/${userId}/taps/sftp?path=${path}`);
}

export function getSelectedFiles(tap = "sftp-files", flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.GET(`${flow}/${userId}/taps/${tap}/files`)
}

export function updateSelectedFiles(files, tap = "sftp-files", flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.POST(`${flow}/${userId}/taps/${tap}/files`, {
    body: JSON.stringify({
      files,
    }),
  });
}

// FILES

export function getColumnMapping(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.GET(`${flow}/${userId}/taps/file/mapping`);
}

export function uploadColumnMapping(
  columnMapping,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  return Request.POST(`${flow}/${userId}/taps/file/mapping`, {
    body: JSON.stringify({
      mapping: {
        columns: columnMapping,
      },
    }),
  });
}

export function getUploadedFiles(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.GET(`${flow}/${userId}/taps/file`);
}

export function deleteUploadedFiles(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.DELETE(`${flow}/${userId}/taps/file`);
}

export function generatePresignedUploadUrl(filename, fileType, entityType, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const url = `${flow}/${userId}/${entityType}/file/url`

  if (!['taps', 'connectors'].includes(entityType)) {
    throw new Error('Invalid entity type, must be taps or connectors, provided: ' + entityType)
  }

  if (!filename || !fileType) {
    throw new Error('Filename and file type are required')
  }

  return Request.POST(url, {
    body: JSON.stringify({
      file_name: filename,
      file_type: fileType,
    }),
  });
}

export function uploadFiles(files, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  const formData = new FormData();

  for (const file of files) {
    formData.append(file.name, file);
  }

  return Request.POST(`${flow}/${userId}/taps/file`, { body: formData, headers: { 'Content-Type': undefined } });
}

// JOBS
export function getJobHistory(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId(), entityId = undefined, entityType = undefined) {
  const params = new URLSearchParams({
    ...(entityId && { entity_id: entityId }),
    ...(entityType && { entity_type: entityType }),
  });

  return Request.GET(`${flow}/${userId}/jobs?${params}`);
}

export function getJob(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId(), entityId = undefined, entityType = undefined) {
  const params = new URLSearchParams({
    ...(entityId && { entity_id: entityId }),
    ...(entityType && { entity_type: entityType }),
  });

  return Request.GET(`${flow}/${userId}/jobs/latest?${params}`);
}

export function getJobStatus(
  jobRoot,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId(),
) {
  const params = new URLSearchParams({
    ...(jobRoot && { job_root: jobRoot }),
  });

  return Request.GET(`${flow}/${userId}/jobs/status?${params}`);
}


export function createJob(
  entityId,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId(),
  startDate = undefined,
  jobType = undefined,
) {
  // check if entityId, flow and userId are set and not empty
  const job_name = entityId
    ? `${flow}-${entityId}-${moment().format('YYMMDD-HHmmss')}`
    : `${flow}-${moment().format('YYMMDD-HHmmss')}`

  // Call the onStartJob listener here, if it is set
  const listener = Selectors.getListener();
  if (listener && listener.onStartJob) {
    listener.onStartJob(entityId, flow, userId);
  }

  const payload = { job_name, tap: entityId, override_start_date: startDate };

  if (jobType) {
    payload.connector_id = entityId;
    payload.job_type = jobType;
    delete payload.tap;
  }
  const POST = jobType ? RequestV2.POST : Request.POST;

  return POST(`${flow}/${userId}/jobs`, { body: JSON.stringify(payload) });
}

// JOB SCHEDULE
export function getSchedule(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId(), connectorId = undefined) {
  const params = new URLSearchParams({ ...(connectorId && { connector_id: connectorId }) })

  return Request.GET(`${flow}/${userId}/jobs/schedule?${params}`);
}

export function updateSchedule(schedule, flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return Request.PUT(`${flow}/${userId}/jobs/schedule`, {
    body: JSON.stringify(schedule),
  });
}

export function deleteSchedule(flow = Selectors.getSelectedFlow(), userId = Selectors.getTenantId(), connector_id = undefined) {
  const params = new URLSearchParams({ ...(connector_id && { connector_id: connector_id }), hard_delete: 'false' });

  return Request.DELETE(`${flow}/${userId}/jobs/schedule?${params}`);
}

// MISC
export function isEntityLinked(name, envId = Selectors.getEnvId(), userId = Selectors.getTenantId()) {
  let url = `entity/${envId}/${userId}/linked?entity=${name}`;
  return Request.GET(url, {}, { env: false });
}

// field map

export function discoverLinkedTargetCatalog(
  targetName,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedTargets/discover?target_name=${targetName}`;

  return Request.GET(url);
}

export function updateLinkedSource(
  tap,
  fieldMapUpdate,
  flowId = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flowId}/${userId}/linkedSources`;

  return Request.PATCH(url, { body: JSON.stringify({ field_map: fieldMapUpdate, tap }) });
}

export function updateLinkedSourceConfig(
  tap,
  config,
  flowId = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flowId}/${userId}/linkedSources`;

  return Request.PATCH(url, { body: JSON.stringify({ tap, config }) });
}

export function updateLinkedConnector(
  connector_id,
  fieldMapUpdate,
  flowId = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const searchParams = new URLSearchParams();

  const jwtToken = Selectors.getJwtToken();

  if (jwtToken) {
    searchParams.set('token', jwtToken);
  }

  const url = `${flowId}/${userId}/linkedConnectors?${searchParams.toString()}`;

  return RequestV2.PATCH(
    url,
    { body: JSON.stringify({ field_map: fieldMapUpdate, connector_id }) },
  );
}

export function updateLinkedConnectorConfig(
  connector_id,
  config,
  flowId = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const searchParams = new URLSearchParams();

  const jwtToken = Selectors.getJwtToken();

  if (jwtToken) {
    searchParams.set('token', jwtToken);
  }

  const url = `${flowId}/${userId}/linkedConnectors?${searchParams.toString()}`;

  return RequestV2.PATCH(
    url,
    { body: JSON.stringify({ config, connector_id }) },
  );
}

export function discoverLinkedSourceCatalog(
  tapName,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedSources/discover?tap_name=${tapName}`;

  return Request.GET(url);
}

export function discoverLinkedConnectorCatalog(
  connectorId,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedConnectors/discover?connector_id=${connectorId}`;

  return RequestV2.GET(url);
}

export function pollDiscoverLinkedSource(
  tapName,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedSources/discover/poll?tap_name=${tapName}`;

  return Request.GET(url);
}

export function pollDiscoverLinkedConnector(
  connectorId,
  flow = Selectors.getSelectedFlow(),
  userId = Selectors.getTenantId()
) {
  const url = `${flow}/${userId}/linkedConnectors/discover/poll?connector_id=${connectorId}`;

  return RequestV2.GET(url);
}

//  TENANT
export function updateTenantMapping(
  mapping,
  entityType,
  entityId,
  envId = Selectors.getEnvId(),
  userId = Selectors.getTenantId(),
  flow = Selectors.getSelectedFlow(),
) {
  const url = `tenant/${envId}/${userId}/mapping`
  return Request.PUT(url, { body: JSON.stringify({ config: { mapping }, entityType, entityId, flow }) }, { env: false })
}

export function updateTenantMetadata(
  tenantMetadata,
  envId = Selectors.getEnvId(),
  userId = Selectors.getTenantId()

) {
  const url = `tenant/${envId}/${userId}/metadata`

  return Request.PUT(url, { body: JSON.stringify({ config: { metadata: tenantMetadata } }) }, { env: false })
}

export function fetchTenantConfig(
  envId = Selectors.getEnvId(),
  userId = Selectors.getTenantId(),
) {
  const url = `tenant/${envId}/${userId}/mapping`
  return Request.GET(url, undefined, { env: false });
}

export function resetSourceState(tapName, flowId = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  let url = `${flowId}/${userId}/linkedSources/state?tap_name=${tapName}`;

  return Request.DELETE(url);
}


export function resetConnectorStateV2(connectorId, flowId = Selectors.getSelectedFlow(), userId = Selectors.getTenantId()) {
  return RequestV2.DELETE(`${flowId}/${userId}/linkedConnectors/state?connector_id=${connectorId}`);
}


export function createOauthStateToken(state) {
  return Request.POST('oauth/state/token', { body: JSON.stringify(state) }, { env: false });
}
